
$( document ).ready(function() {

// home page banner sider 
$('.banner_slide-list').slick({
  dots: false,
  arrows: true,
  infinite: true,  
  slidesToShow: 1,
});


$(document).on("click", ".targetbay-reviews-count-field", function() {
  $('a[href="#tab-review"]').trigger('click');

  // Optional scroll
  $('html, body').animate({
    scrollTop: $("#targetbay_reviews").offset().top - 200
  }, 500);
});

  
  
// review sider 
 $('.reviewBox').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
   fade:true,
  asNavFor: '.review_avtar'
});
$('.review_avtar').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.reviewBox',
  dots: false,
  arrows: false,
  centerMode: true,
   
});


  // collection tab slider 
if ($(window).width() <1440) {
$('.tab_slider_main').slick({
  dots: false,
  arrows:true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
}

  




// product media slider

$('.slider-galeria').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: false,
  asNavFor: '.slider-galeria-thumbs',
});
$('.slider-galeria-thumbs').slick({
  slidesToShow: 4,
  draggable:true,
  slidesToScroll: 1,
  arrows: true,
  asNavFor: '.slider-galeria',
  vertical: true,
  verticalSwiping: true,
  infinite: false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});



});
  
